<template>
  <nav class="navbar navbar-default navbar-static-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
      <button
        type="button"
        class="navbar-toggle"
        data-toggle="collapse"
        data-target=".navbar-collapse"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="/client">
        <img v-bind:src="config.SITE_LOGO" :alt="config.SITE_NAME">
      </a>
    </div>

    <ul class="nav navbar-top-links navbar-right hidden-xs hidden-sm">
      <li>
        <a class="navbar-help" href="/client/support">
          <i class="fa fa-info-circle"></i>
          <span>{{$t('navbar.need_help')}}</span>?
        </a>
      </li>
      <li class="dropdown">
        <a class="dropdown-toggle navbar-user" data-toggle="dropdown" href="#">
          {{$t('navbar.welcome')}}!
          <span>{{user.fullName}}</span>
          <img :src="'/static/assets/images/avatars/' + user.avatarUrl" alt="image">
          <span class="fa fa-caret-down"></span>
        </a>
        <ul class="dropdown-menu dropdown-user">
          <li>
            <a href="/client/profile">
              <i class="fa fa-user"></i>
              {{$t('navbar.user_profile')}}
            </a>
          </li>
          <li class="divider"></li>
          <li>
            <a href="#" v-on:click="handleLogout()">
              <i class="fa fa-sign-out-alt"></i>
              {{$t('navbar.logout')}}
            </a>
          </li>
        </ul>
      </li>
      <!-- /.dropdown -->
      <li class="dropdown">
        <a class="dropdown-toggle navbar-alerts" data-toggle="dropdown" href="#">
          <i class="fas fa-globe"></i>
        </a>
        <ul class="dropdown-menu dropdown-user">
          <li v-for="l of $t('navbar.languages')">
            <a href="#" v-on:click="changeLocale(l.code)">{{l.name}}</a>
          </li>
        </ul>
      </li>
    </ul>
    <!-- /.navbar-top-links -->
    <div class="navbar-default sidebar" role="navigation">
      <div class="sidebar-nav navbar-collapse">
        <ul class="nav" id="side-menu">
          <li class="visible-xs custom-search-form-nav">
            <div class="custom-search-form">
              <i class="fa fa-search"></i>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Search...">
              </div>
            </div>
          </li>
          <li>
            <a href="/client">
              <i class="fa fa-home"></i>
              {{$t('navbar.dashboard')}}
            </a>
          </li>
          <li class="hidden-xs">
            <a href="/client/profile">
              <div
                class="profile"
                v-bind:style="{ 'background-image': 'url(/static/assets/images/avatars/' + user.avatarUrl + ')' }"
              >
                <div class="tool">
                  <i class="fa fa-cog"></i>
                </div>
              </div>
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fa fa-user-cog"></i>
              {{$t('navbar.account')}}
              <span class="fa arrow"></span>
            </a>
            <ul class="nav nav-second-level">
              <li v-for="mt4Account of mt4Accounts">
                <a
                  href="#"
                  v-on:click="handleSwitchMt4Account(mt4Account)"
                  v-show="!mt4Account.mustBeCreated"
                  :class="mt4Account.default ? 'selected-mt4' : ''"
                >{{mt4Account.description}}</a>
                <a
                  href="#"
                  v-on:click="handleCreateMt4Account"
                  v-show="mt4Account.mustBeCreated"
                >{{$t('navbar.create_new_account')}} ({{mt4Account.mT4ServerTypeDescription}})</a>
              </li>
            </ul>
            <!-- /.nav-second-level -->
          </li>
          <li>
            <a href="/client/deposit  ">
              <i class="fas fa-coins align"></i>
              {{$t('navbar.deposit_funds')}}
            </a>
          </li>
          <li>
            <a href="/client/withdrawal">
              <i class="fas fa-hand-holding-usd align"></i>
              {{$t('navbar.withdrawal')}}
            </a>
          </li>
          <li>
            <a :href="config.METATRADER_URL" target="_blank">
              <i class="fas fa-download align"></i>
              {{$t('navbar.downloadmt4')}}
            </a>
          </li>
          <li v-show="config.SHOW_WEBTRADER_LINK">
            <a :href="config.WEBTRADER_URL" target="_blank">
              <i class="fas fa-laptop align"></i>
              {{$t('navbar.webtrader')}}
            </a>
          </li>
          <li>
            <a href="/client/profile#documents">
              <i class="fas fa-file-alt align"></i>
              {{$t('navbar.documentation')}}
            </a>
          </li>
          <li class="hidden-xs hidden-sm">  
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
          </li>
          <li>
            <a href="/client/profile">
              <i class="far fa-user-circle"></i>
              {{$t('navbar.user_profile')}}
            </a>
          </li>
          <li class="visible-xs visible-sm">
            <a href="/client/support">
              <i class="fa fa-info-circle"></i>
              {{$t('navbar.need_help')}}
            </a>
          </li>
        </ul>
        <hr>
        <div class="navbar-footer">
          <p v-html="config.COPYRIGHT"></p>
          <p>
            <a :href="config.FACEBOOK_URL" target="_blank">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a :href="config.TWITTER_URL" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
          </p>
        </div>
      </div>
      <!-- /.sidebar-collapse -->
    </div>
    <!-- /.navbar-static-side -->
  </nav>
</template>

<script>
import AccountService from "@/services/AccountService";
import AuthService from "@/services/AuthService";
import LangService from "@/services/LangService";
import EventBus from "@/event-bus";
import swal from "sweetalert2";
import siteConfiguration from '@/config';

let accountService = new AccountService();

export default {
  name: "app-nav",
  data() {
    return {
      pendingAccountTypes: [],
      user: {},
      selectedMt4Account: {},
      mt4Accounts: [],
      config : siteConfiguration
    };
  },
  created() {
    var t = this;
    this.user = AuthService.getUser();

    EventBus.$on('onUpdateComponent', r =>{
      this.populateComponent();
    });
    
    this.populateComponent();

    EventBus.$on("profileUpdated", () => {
      this.user = AuthService.getUser();
    });
  },
  methods: {
    populateComponent() {
      accountService.getMT4Accounts().then(r => {
        this.mt4Accounts = r.data;
      });
    },
    handleLogin() {
      AuthService.login();
    },
    handleLogout() {
      AuthService.logout();
    },
    isLoggedIn() {
      return this.AuthService.isLoggedIn();
    },
    changeLocale(lang) {
      this.$i18n.locale = lang;
      LangService.setLang(lang);
    },
    handleSwitchMt4Account(data) {
      EventBus.$emit("onSetDefaultMt4Account", data);
    },
    handleCreateMt4Account() {
      swal({
        title: this.$t("shared.messages.creating_mt4_account"),
        text: this.$t("shared.messages.please_wait")
      });
      swal.showLoading();
      accountService
        .createMT4LiveAccount()
        .then(r => {
          EventBus.$emit("onUpdateDefaultMt4Account", null);
          EventBus.$emit("onUpdateComponent", null);
          swal.close();
        })
        .catch(e => {
          swal({
            type: "error",
            title: "Error",
            text: e.response
          });
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-right {
  margin-right: 0px !important;
}

.log {
  margin: 5px 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue